import React, { useRef, useEffect, useState } from "react";
import {
  DirectionsRenderer,
  GoogleMap, LoadScript, Marker, Autocomplete, StandaloneSearchBox
} from "@react-google-maps/api";
import "primeflex/primeflex.css";
import "primeicons/primeicons.css";
import { Card } from "primereact/card";
import { Image } from "primereact/image";
import { RadioButton } from "primereact/radiobutton";
import "primereact/resources/primereact.css";
import "primereact/resources/themes/saga-blue/theme.css";
import { classNames } from "primereact/utils";
// import {
//   GoogleMap,
//   Marker,
//   withGoogleMap,
//   SearchBox,
//   withScriptjs,
// } from "react-google-maps";
import { Controller, useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import {
  appendAddressPermData, appendAddressTempData, setHasPermanentAddressSame, setLatLng, setLocationType
} from "../../redux/addressSlice";
import { setSpecificDocument } from "../../redux/documentSlice";
import { setGlobalList } from "../../redux/routerSlice";
import AddressInput from "../input/AddressInput";
import ApiBaseURLProps from "../other/apiBaseURL";
import FileUploadComponent from "../other/fileUploadComponent";
import ApiService from "../service/apiService";
import { SaveButton } from "./declerationDetails";
import { NextButton, PrevButton } from "./kycSidebar";
import { DynamicFieldSection } from "./personalDetails";
import MapComponent from "../../helper/MapComponent";



const footer = () => (
  <div class="p-field p-col-12 p-md-12">
    <div className="p-grid" style={{ flex: 3, padding: "0 10px" }}>
      <div style={{ flex: 1 }}>
        <PrevButton />
      </div>
      <div style={{ flex: 1 }}>
        <center>
          <SaveButton style={{ flex: 1 }} />
        </center>
      </div>
      <div style={{ flex: 1 }}>
        <center>
          <NextButton />
        </center>
      </div>
    </div>
  </div>
);

function AddressDetails(props) {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [LatLng, setLatLngState] = useState({ markerPosition: { lat: 27.7172, lng: 85.324 } });
  const apiKey = "AIzaSyArYcJ1r7mpkhMWclh7aH363M-hLMxXyBs"; // API key
  const libraries = ["places"]; // required libraries for Google Maps

  const globalList = useSelector((state) => state.routerData.globalList);
  const addressDetails = useSelector((state) => state.addressDetails);
  console.log("main------------------------------------", addressDetails);

  // Add nationality selector
  const nationality = useSelector((state) => state.personalDetails.nationality);

  const locationType = addressDetails.locationType;
  // const LatLng = addressDetails.LatLng;
  const errorObj = addressDetails.errors;
  const locationError = errorObj && errorObj.locationError && errorObj.locationError.message;
  const hasPermanentAddressSame = addressDetails.hasPermanentAddressSame;
  const documentTypeList = useSelector(
    (state) => state.documentDetails.documentTypeList
  );
  const documentType = documentTypeList.find((d) => d.code === "MP") || {};
  const formType = useSelector((state) => state.routerData.formType);
  const documentList = useSelector(
    (state) => state.documentDetails.documentList
  );
  const mapImage = documentList.find((d) => d.documentTypeId === "MP") || {};
  const { control, formState: { errors } } = useForm({});

  const getFormErrorMessage = (name) => {
    return (
      errors[name] && <small className="p-error">{errors[name].message}</small>
    );
  };

  const [locationTypeEntry, setLocationTypeEntry] = useState(null);
  useEffect(() => {
    if (globalList && globalList.locationType) {
      setLocationTypeEntry(globalList.locationType);
      if (globalList.locationType === "I" || globalList.locationType === "G") {
        dispatch(setLocationType(globalList.locationType));
      }
    }
  }, [globalList, locationType, dispatch]);

  useEffect(() => {
    if (!globalList || Object.keys(globalList).length === 0) {
      ApiService.getGlobalSetting().then((response) => {
        const res = response.data.data;
        if (res.length !== 0) {
          dispatch(setGlobalList(res[0]));
        }
      });
    }
  }, [globalList, dispatch]);

  useEffect(() => {
    setLatLngState(addressDetails.LatLng);
  }, [addressDetails.LatLng]);

  // useEffect(() => {
  //   dispatch(setSpecificDocument("MP"));
  // }, [formType, dispatch]);

  // Add useEffect to synchronize country with nationality
  useEffect(() => {
    if (nationality === "NP") {
      // dispatch(setCountry("NP"));
      // dispatch(setPerCountry("NP"));
    }
  }, [nationality, dispatch]);

  return (
    <Card
      className="p-col-12 p-md-12 main-card"
      header={() => (
        <h3 className="p-col-12 p-md-12 text-center">
          <i className="pi pi-map-marker"></i> {t("addressDetails")}
        </h3>
      )}
      footer={footer}
    >
      <div className=" p-grid p-fluid  p-col-12 p-md-12" style={{ margin: 0 }}>
        <div className="p-grid p-fluid" style={{ margin: 0 }}>
          <h4 className=" p-col-12 p-md-12">
            <p className="section-title ">{t("currentAddress")}</p>
          </h4>
          <AddressInput
            errorObj={errorObj}
            hide={(formType === 'I' ? { website: true, fax: true } : { fax: true })}
            data={addressDetails}
            nationality={nationality}
            onChange={data => {
              dispatch(appendAddressTempData(data));
            }} />

          <h4 className=" p-col-12 p-md-12">
            <p className="section-title ">{t("permanentAddress")}</p>
          </h4>
          <div className="p-field p-col-12 p-md-12">
            <label className="p-col-12 p-md-12" style={{ textAlign: "center" }}>
              {t("isPermanentAddressSame")}*
            </label>
            <div
              className="p-field-radiobutton p-col-12"
              style={{ justifyContent: "center" }}
            >
              <Controller
                name="hasPermanentAddressSame"
                control={control}
                rules={{ required: "Address is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={true}
                    onChange={(e) =>
                      dispatch(setHasPermanentAddressSame(e.value))
                    }
                    checked={hasPermanentAddressSame === true}
                    className={classNames({
                      "p-invalid": fieldState.invalid,
                    })}
                  />
                )}
              />
              <label style={{ marginRight: "10px" }}>{t("yes")}</label>
              <Controller
                name="hasPermanentAddressSame"
                control={control}
                rules={{ required: "Address is required." }}
                render={({ field, fieldState }) => (
                  <RadioButton
                    id={field.name}
                    {...field}
                    value={false}
                    onChange={(e) =>
                      dispatch(setHasPermanentAddressSame(e.value))
                    }
                    checked={hasPermanentAddressSame === false}
                    className={classNames({
                      "p-invalid": fieldState.invalid,
                    })}
                  />
                )}
              />
              <label>{t("no")}</label>
            </div>
          </div>
          {getFormErrorMessage("hasPermanentAddressSame")}

          <AddressInput
            errorObj={errorObj}
            hide={{ website: true, emailId: true, mobileNo: true, fax: true }}
            data={addressDetails}
            disabled={hasPermanentAddressSame}
            prefix="per"
            nationality={nationality}
            onChange={data => {
              dispatch(appendAddressPermData(data));
            }} />
        </div>

        <h4>
          <p className="section-title p-col-12 p-md-12">{t("location")}</p>
        </h4>

        <div className="p-field p-col-12 p-md-12">

          {locationTypeEntry != 'I' && locationTypeEntry != 'G' &&
            <>
              <label className="p-col-12 p-md-6">
                {t("type")}*<span style={{ color: "red" }}>{locationError}</span>
              </label>

              <div className="p-col-4" style={{ padding: 0 }}>
                <div className="p-field-radiobutton p-col-12 p-md-12 ">
                  <Controller
                    name="locationType"
                    control={control}
                    rules={{ required: "Location is required." }}
                    render={({ field, fieldState }) => (
                      <RadioButton
                        id={field.name}
                        {...field}
                        value={"G"}
                        onChange={(e) => dispatch(setLocationType("G"))}
                        checked={locationType === "G"}
                        className={classNames({ "p-invalid": fieldState.invalid })}
                      />
                    )}
                  />
                  <label className="p-mr-5">{t("gps")}</label>
                  <Controller
                    name="locationType"
                    control={control}
                    rules={{ required: "Location is required." }}
                    render={({ field, fieldState }) => (
                      <RadioButton
                        id={field.name}
                        {...field}
                        value={"I"}
                        onChange={(e) => dispatch(setLocationType("I"))}
                        checked={locationType === "I"}
                        className={classNames({ "p-invalid": fieldState.invalid })}
                      />
                    )}
                  />
                  <label className="p-mr-5">{t("image")}</label>
                </div>
              </div>
            </>
          }
        </div>
        {getFormErrorMessage("locationType")}

        {(locationTypeEntry === 'G' || (locationTypeEntry != 'G' && locationType === 'G')) && (
          <div style={{ width: 800, margin: "0px auto" }}>
            <MapComponent
              dispatch={dispatch}
              LatLng={LatLng}
            />
          </div>
        )}

        {((locationTypeEntry === 'I' || (locationTypeEntry != 'I' && locationType === 'I'))) &&
          <div
            className="p-field p-col-12 p-md-12"
          >
            <FileUploadComponent
              type="map"
              data={{ ...mapImage, ...documentType }}
              onUpload={(data) => {
                dispatch(
                  setSpecificDocument({
                    documentTypeCode: 9,
                    documentTypeId: "MP",
                    fileId: data.storageFileName,
                  })
                );
              }}
            />
          </div>
        }

        <DynamicFieldSection />
      </div>
    </Card >
  );
}

const containerStyle = {
  width: "400px",
  height: "400px",
};

const center = {
  lat: -3.745,
  lng: -38.523,
};


let destination = { lat: 41.756795, lng: -78.954298 };
let origin = { lat: 40.756795, lng: -73.954298 };

let directionsService; // kg {}

export default AddressDetails;
